jQuery(document).ready(function ($) {

    /*var eventFullnameSelector = '.event-fullname';
    $(eventFullnameSelector).after('<span class="bar"></span><label class="f7-e-name f7-label">FULL NAME</label>');

    var eventPhoneSelector = '.event-phone';
    $(eventPhoneSelector).after('<span class="bar"></span><label class="f7-e-phone f7-label">PHONE</label>');

    var eventEmailSelector = '.event-email';
    $(eventEmailSelector).after('<span class="bar"></span><label class="f7-e-email f7-label">EMAIL</label>');

    var eventOrgSelector = '.event-org';
    $(eventOrgSelector).after('<span class="bar"></span><label class="f7-e-org f7-label">ORGANIZATION</label>');

    var eventMsgSelector = '.event-msg';
    $(eventMsgSelector).after('<span class="bar"></span><label class="f7-e-msg f7-label">MESSAGE</label>');

    $('.wpcf7-form-control').focus(function () {
        $(this).siblings('label').addClass('active');
    }).blur(function () {
        $(this).siblings('label').removeClass('active');

        if ($(this).val().length > 0) {
            $(this).siblings('label').addClass('content');
        } else {
            $(this).siblings('label').removeClass('content');
        }
    });*/

});